<template>
  <div style="text-align:left">
    <Breadcrumb style="margin: 0px 10px 20px">
        <BreadcrumbItem to="/adAdmin">广告管理</BreadcrumbItem>
        <BreadcrumbItem>创建广告</BreadcrumbItem>
    </Breadcrumb>
    <Card>
		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150" label-position="left" style="margin-left:10px">
            <Spin size="large" fix v-if="spinShow"></Spin>
            <FormItem label="广告来源" prop="source">
                <RadioGroup v-model="formValidate.source" @on-change="handleSeleteSource">
                    <Radio label="0">自营广告</Radio>
                    <Radio label="1">第三方广告</Radio>
                    <Radio label="2">商品广告</Radio>
                    <Radio label="3">图片弹窗广告</Radio>
                    <Radio label="4">文案弹窗广告</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="广告类型" prop="ad_content_type">
                <RadioGroup v-model="formValidate.ad_content_type">
                    <Radio label="0">无</Radio>
                    <Radio label="1">营收业务</Radio>
                    <Radio label="2">主推活动</Radio>
                    <Radio label="3">常规活动</Radio>
                    <Radio label="4">会员宣导</Radio>
                    <Radio label="5">用户运营</Radio>
                </RadioGroup>
            </FormItem>
            <div v-if="formValidate.source=='0'">
                <FormItem label="广告样式" prop="template_id">
                    <Select v-model="formValidate.template_id" style="width:300px" clearable @on-select="handleSeleteTemplate" @on-clear="handleClearTemplate">
                        <Option v-for="item in templates" :value="item.template_id+''" :key="item.template_id">
                            {{ item.template_name }}
                        </Option>
                    </Select>
                    <div class="box3" v-if="template_image != ''">
                        <img :src="template_image" alt="" style="max-height:150px;height:100%;border:1px solid rgb(158, 156, 156);float:left">
                        <div style="display: table-cell;height:150px;vertical-align: middle;margin-left:10px;text-align: center;padding-left: 10px;">
                            <p>{{template_description}}</p>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="广告名称" prop="title">
                    <Input v-model="formValidate.title" style="width:300px"></Input>
                </FormItem>
                <FormItem label="素材类型" prop="material_type">
                    <RadioGroup v-model="formValidate.material_type">
                        <Radio label="1">静态图片</Radio>
                        <Radio label="2">动态视频</Radio>
                        <Radio label="3">纯文本</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="广告图" prop="material_url" v-if="formValidate.material_type!=='3'">
                    <Upload
                        style="min-width:180px;max-width:280px;float:left"
                        :before-upload="handleUpload"
                        :accept="Accept"
                        :format="Format"
                        type="drag"
                        action="">
                        <div v-if="!formValidate.material_url">
                            <!-- <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon> -->
                            <div style="display: table-cell;height:80px;vertical-align: middle;text-align: center;width:178px">
                                <p>点击上传</p>
                                <p style="color:rgb(158, 156, 156);">{{template_size}}</p>
                            </div>
                        </div>
                        <div v-if="formValidate.material_url" style="min-height:100px;max-height:150px">
                            <img :src="formValidate.material_url" v-if="formValidate.material_type=='1'" style="max-width:300px;max-height:200px;width:100%"/>
                            <video :src="formValidate.material_url" v-else controls="controls" style="max-height:150px"/>
                            <Spin fix v-show="uploading"></Spin>
                        </div>
                    </Upload>
                    <Button size="small" style="margin-left:10px" @click="openAiDialog" :loading="aiOpening">AI生成</Button>
                </FormItem>
                <FormItem label="文案描述" prop="content">
                    <Input v-model="formValidate.content" placeholder="请输入15个字以内的描述文案" style="width:300px"></Input>
                </FormItem>
                <FormItem label="button名称" prop="button_name">
                    <Input v-model="formValidate.button_name" placeholder="请输入4个字以内的按钮名称" style="width:300px"></Input>
                </FormItem>
                <FormItem label="跳转链接">
                    <Input v-model="formValidate.jump_link" placeholder="https：" style="width:300px"></Input>
                </FormItem>
                <FormItem label="跳转类型" prop="jump_type" v-show="formValidate.jump_link != ''">
                    <RadioGroup v-model="formValidate.jump_type">
                        <Radio label="1">内部H5跳转</Radio>
                        <Radio label="2">APP原生页面</Radio>
                        <Radio label="3">系统浏览器外部链接</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="广告频率" prop="frequency">
                    <Select v-model="formValidate.frequency" style="width:300px">
                        <Option value="1">每次打开</Option>
                        <Option value="2">每天一次</Option>
                        <Option value="3">每周一次</Option>
                        <Option value="4">每月一次</Option>
                        <Option value="7" v-if="['1', '5'].includes(String(formValidate.template_id))">每日弹1次，共弹2次</Option>
                        <Option value="8" v-if="['1', '5'].includes(String(formValidate.template_id))">点击一次后不再投放</Option>
                    </Select>
                </FormItem>
                <FormItem label="广告时长" prop="duration">
                    <Select v-model="formValidate.duration" style="width:300px">
                        <Option value="0">不限</Option>
                        <Option value="1">1秒</Option>
                        <Option value="2">2秒</Option>
                        <Option value="3">3秒</Option>
                        <Option value="5">5秒</Option>
                        <Option value="10">10秒</Option>
                    </Select>
                </FormItem>
            </div>
            <div v-if="formValidate.source=='1'">
                <FormItem label="广告参数" prop="contents">
                    <Input v-model="formValidate.contents" type="textarea" :rows="4" placeholder="请输入广告参数" style="width:300px"></Input>
                </FormItem>
            </div>
            <div v-if="formValidate.source=='2'">
                <FormItem label="广告样式" prop="template_id">
                    <Select v-model="formValidate.template_id" style="width:300px" clearable @on-select="handleSeleteTemplate" @on-clear="handleClearTemplate">
                        <Option v-for="item in templates" :value="item.template_id+''" :key="item.template_id">
                            {{ item.template_name }}
                        </Option>
                    </Select>
                    <div class="box3" v-if="template_image != ''">
                        <img :src="template_image" alt="" style="max-height:150px;height:100%;border:1px solid rgb(158, 156, 156);float:left">
                        <div style="display: table-cell;height:150px;vertical-align: middle;margin-left:10px;text-align: center;padding-left: 10px;">
                            <p>{{template_description}}</p>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="广告名称" prop="title">
                    <Input v-model="formValidate.title" style="width:300px"></Input>
                </FormItem>
                <FormItem label="素材类型" prop="material_type">
                    <RadioGroup v-model="formValidate.material_type">
                        <Radio label="1">静态图片</Radio>
                        <Radio label="2">动态视频</Radio>
                        <Radio label="3">纯文本</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="广告图" prop="material_url" v-if="formValidate.material_type!=='3'">
                    <Upload
                        style="min-width:180px;max-width:280px;float:left"
                        :before-upload="handleUpload"
                        :max-size="10240"
                        :accept="Accept"
                        :format="Format"
                        type="drag"
                        action="">
                        <div v-if="!formValidate.material_url">
                            <div style="display: table-cell;height:80px;vertical-align: middle;text-align: center;width:178px">
                                <p>点击上传</p>
                                <p style="color:rgb(158, 156, 156);">{{template_size}}</p>
                            </div>
                        </div>
                        <div v-if="formValidate.material_url" style="min-height:100px;max-height:150px">
                            <img :src="formValidate.material_url" v-if="formValidate.material_type=='1'" style="max-width:300px;max-height:200px;width:100%"/>
                            <video :src="formValidate.material_url" v-else controls="controls" style="max-height:150px"/>
                            <Spin fix v-show="uploading"></Spin>
                        </div>
                    </Upload>
                    <Button size="small" style="margin-left:10px" @click="openAiDialog" :loading="aiOpening">AI生成</Button>
                </FormItem>
                <FormItem label="来源" prop="product_source">
                    <Select v-model="formValidate.product_source" style="width:100px">
                        <Option value="1">淘宝</Option>
                        <Option value="2">天猫</Option>
                        <Option value="3">京东</Option>
                        <Option value="4">拼多多</Option>
                        <Option value="5">轻牛专属</Option>
                    </Select>
                </FormItem>
                <FormItem label="付款价格" prop="final_price">
                    <Input v-model="formValidate.final_price" style="width:100px" type="number" @on-change="handleChangePrice"></Input> ￥
                </FormItem>
                <FormItem label="优惠券" prop="coupon_amount">
                    <Input v-model="formValidate.coupon_amount" style="width:100px" type="number" @on-change="handleChangePrice"></Input> ￥
                </FormItem>
                <FormItem label="原价" prop="price">
                    <Input v-model="formValidate.price" style="width:100px" type="number"></Input> ￥
                </FormItem>
                <FormItem label="优先级" prop="rank">
                    <Select v-model="formValidate.rank" style="width:100px">
                        <Option value="-2">-2</Option>
                        <Option value="-1">-1</Option>
                        <Option value="0">0</Option>
                        <Option value="1">1</Option>
                        <Option value="2">2</Option>
                    </Select>
                </FormItem>
                <FormItem label="商品描述" prop="good_content">
                    <Input v-model="formValidate.good_content" style="width:300px"></Input>
                </FormItem>
                <FormItem label="跳转链接" prop="jump_link">
                    <Input v-model="formValidate.jump_link" placeholder="https：" style="width:300px"></Input>
                </FormItem>
                <FormItem label="跳转类型" prop="jump_type" v-show="formValidate.jump_link != ''">
                    <RadioGroup v-model="formValidate.jump_type">
                        <Radio label="1">内部H5跳转</Radio>
                        <Radio label="2">APP原生页面</Radio>
                        <Radio label="3">系统浏览器外部链接</Radio>
                    </RadioGroup>
                </FormItem>
            </div>
            <div v-if="formValidate.source=='3'">
                <FormItem label="广告样式" prop="template_id">
                    <Select v-model="formValidate.template_id" style="width:300px" clearable @on-select="handleSeleteTemplate" @on-clear="handleClearTemplate">
                        <Option v-for="item in templates" :value="item.template_id+''" :key="item.template_id">
                            {{ item.template_name }}
                        </Option>
                    </Select>
                    <div class="box3" v-if="template_image != ''">
                        <img :src="template_image" alt="" style="max-height:150px;height:100%;border:1px solid rgb(158, 156, 156);float:left">
                        <div style="display: table-cell;height:150px;vertical-align: middle;margin-left:10px;text-align: center;padding-left: 10px;">
                            <p>{{template_description}}</p>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="广告名称" prop="title">
                    <Input v-model="formValidate.title" style="width:300px"></Input>
                </FormItem>
                <FormItem label="素材类型" prop="material_type">
                    <RadioGroup v-model="formValidate.material_type">
                        <Radio label="1">静态图片</Radio>
                        <Radio label="2">动态视频</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="广告图" prop="material_url">
                    <Upload
                        style="min-width:180px;max-width:280px;float:left"
                        :before-upload="handleUpload"
                        :max-size="10240"
                        :accept="Accept"
                        :format="Format"
                        type="drag"
                        action="">
                        <div v-if="!formValidate.material_url">
                            <div style="display: table-cell;height:80px;vertical-align: middle;text-align: center;width:178px">
                                <p>点击上传</p>
                                <p style="color:rgb(158, 156, 156);">{{template_size}}</p>
                            </div>
                        </div>
                        <div v-if="formValidate.material_url" style="min-height:100px;max-height:150px">
                            <img :src="formValidate.material_url" v-if="formValidate.material_type=='1'" style="max-width:300px;max-height:200px;width:100%"/>
                            <video :src="formValidate.material_url" v-else controls="controls" style="max-height:150px"/>
                            <Spin fix v-show="uploading"></Spin>
                        </div>
                    </Upload>
                    <Button size="small" style="margin-left:10px" @click="openAiDialog" :loading="aiOpening">AI生成</Button>
                </FormItem>
                <FormItem label="来源" prop="product_source">
                    <Select v-model="formValidate.product_source" style="width:100px">
                        <Option value="1">淘宝</Option>
                        <Option value="2">天猫</Option>
                        <Option value="3">京东</Option>
                        <Option value="4">拼多多</Option>
                        <Option value="5">轻牛专属</Option>
                    </Select>
                </FormItem>
                <FormItem label="跳转链接" prop="jump_link" class="ivu-form-item ivu-form-item-required">
                    <Input v-model="formValidate.jump_link" placeholder="https：" style="width:300px"></Input>
                </FormItem>
                <FormItem label="跳转类型" prop="jump_type" v-show="formValidate.jump_link != ''">
                    <RadioGroup v-model="formValidate.jump_type">
                        <Radio label="1">内部H5跳转</Radio>
                        <Radio label="2">APP原生页面</Radio>
                        <Radio label="3">系统浏览器外部链接</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="广告频率" prop="frequency">
                    <Select v-model="formValidate.frequency" style="width:300px">
                        <Option value="1">每次打开</Option>
                        <Option value="2">每天一次</Option>
                        <Option value="5">只弹一次</Option>
                        <Option value="6">三天一次</Option>
                        <Option value="7">每日弹1次，共弹2次</Option>
                        <Option value="8">点击一次后不再投放</Option>
                    </Select>
                </FormItem>
            </div>
            <div v-if="formValidate.source=='4'">
                <FormItem label="广告名称" prop="title">
                    <Input v-model="formValidate.title" style="width:300px"></Input>
                </FormItem>
                <FormItem label="弹窗标题" prop="popup_title">
                    <Input v-model="formValidate.popup_title" style="width:300px"></Input>
                </FormItem>
                <FormItem label="弹窗内容" prop="popup_content">
                    <Input v-model="formValidate.popup_content" style="width:300px"></Input>
                </FormItem>
                <Divider />
                <FormItem label="Button1名称" prop="button1_name">
                    <Input v-model="formValidate.button1_name" placeholder="请输入4个字以内的按钮名称" style="width:300px"></Input>
                </FormItem>
                <FormItem label="是否支持跳转" class="ivu-form-item ivu-form-item-required" prop="button1_jump_flag">
                    <RadioGroup v-model="formValidate.button1_jump_flag">
                        <Radio label="0">不支持</Radio>
                        <Radio label="1">支持</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="Button1跳转链接" prop="button1_jump_link" class="ivu-form-item ivu-form-item-required" v-if="formValidate.button1_jump_flag == '1'">
                    <Input v-model="formValidate.button1_jump_link" placeholder="https：" style="width:300px"></Input>
                </FormItem>
                <FormItem label="Button1跳转类型" prop="button1_jump_type" v-if="formValidate.button1_jump_flag == '1'">
                    <RadioGroup v-model="formValidate.button1_jump_type">
                        <Radio label="1">内部H5跳转</Radio>
                        <Radio label="2">APP原生页面</Radio>
                        <Radio label="3">系统浏览器外部链接</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="来源" prop="button1_product_source" v-if="formValidate.button1_jump_flag == '1'">
                    <Select v-model="formValidate.button1_product_source" style="width:100px">
                        <Option value="1">淘宝</Option>
                        <Option value="2">天猫</Option>
                        <Option value="3">京东</Option>
                        <Option value="4">拼多多</Option>
                        <Option value="5">轻牛专属</Option>
                    </Select>
                </FormItem>
                <Divider />
                <FormItem label="Button2名称" prop="button2_name" class="ivu-form-item ivu-form-item-required">
                    <Input v-model="formValidate.button2_name" placeholder="请输入4个字以内的按钮名称" style="width:300px"></Input>
                </FormItem>
                <FormItem label="是否支持跳转" class="ivu-form-item ivu-form-item-required" prop="button2_jump_enable">
                    <RadioGroup v-model="formValidate.button2_jump_flag">
                        <Radio label="0">不支持</Radio>
                        <Radio label="1">支持</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="Button2跳转链接" prop="button2_jump_link" v-if="formValidate.button2_jump_flag == '1'">
                    <Input v-model="formValidate.button2_jump_link" placeholder="https：" style="width:300px"></Input>
                </FormItem>
                <FormItem label="Button2跳转类型" prop="button2_jump_type" v-if="formValidate.button2_jump_flag == '1'">
                    <RadioGroup v-model="formValidate.button2_jump_type">
                        <Radio label="1">内部H5跳转</Radio>
                        <Radio label="2">APP原生页面</Radio>
                        <Radio label="3">系统浏览器外部链接</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="来源" prop="button2_product_source" v-if="formValidate.button2_jump_flag == '1'">
                    <Select v-model="formValidate.button2_product_source" style="width:100px">
                        <Option value="1">淘宝</Option>
                        <Option value="2">天猫</Option>
                        <Option value="3">京东</Option>
                        <Option value="4">拼多多</Option>
                        <Option value="5">轻牛专属</Option>
                    </Select>
                </FormItem>
                <Divider />
                <FormItem label="广告频率" prop="frequency">
                    <Select v-model="formValidate.frequency" style="width:300px">
                        <Option value="1">每次打开</Option>
                        <Option value="2">每天一次</Option>
                        <Option value="5">只弹一次</Option>
                        <Option value="6">三天一次</Option>
                        <Option value="7">每日弹1次，共弹2次</Option>
                        <Option value="8">点击一次后不再投放</Option>
                    </Select>
                </FormItem>
            </div>
            <FormItem label="是否订单引流" v-if="formValidate.source!='1'">
                <RadioGroup v-model="formValidate.order_flow_flag">
                    <Radio label="0">否</Radio>
                    <Radio label="1">是</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="是否会员引流" v-if="formValidate.source!='1'">
                <RadioGroup v-model="formValidate.vip_flow_flag">
                    <Radio label="0">否</Radio>
                    <Radio label="1">是</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
            </FormItem>
		</Form>
	</Card>
    <AiDrawDialog ref="aiDrawDialog" v-model="aiDialogVisible" @set-image="handleSetAdImage" />
    
  </div>
</template>
<script>
import{adTemplateList, createSelfAd, createThirdAd, createProductAd, createImagePopupAd, createTextPopupAd}from "@/request/api"
import Cookies from 'js-cookie';
import axios from 'axios';
import AiDrawDialog from '@/components/common/AiDrawDialog.vue'
export default {
    name: 'createAd',
    meta:{},
    components: { AiDrawDialog },
        data() {
            return {
            Accept: ".png,.jpg,.gif,.bmp,.mp4,.jpeg",//上传文件格式限制
            Format: ['.png','.jpg','.bmp','.gif','.mp4','.jpeg'],//上传文件格式限制
            spinShow: false,
            uploading: false,
            aiDialogVisible: false,
            aiOpening: false,
            templates: [],
            template_dict: {},
            template_image: "",
            template_description: "",
            template_size: "",
            template_name: "",
            formValidate:{
                source: '0',
                template_id: '',
                material_url: '',
                material_type: "1",
                jump_type:'1',
                content: '',
                button_name: '',
                jump_link: '',
                contents: '',
                dates: '',
                product_source: '1',
                title: '',
                coupon_amount: 0,
                price: 0,
                final_price: 0,
                rank: '0',
                good_content: '',
                frequency: '1',
                duration: '0',
                popup_content: '',
                button1_name: '',
                button1_jump_flag: '0',
                button1_product_source: '1',
                button1_jump_link: '',
                button1_jump_type: '1',
                button2_name: '',
                button2_jump_flag: '0',
                button2_product_source: '1',
                button2_jump_link: '',
                button2_jump_type: '1',
                order_flow_flag: '0',
                vip_flow_flag: '0',
                ad_content_type: '0'
            },
            ruleValidate: {
                material_type: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                source: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                ad_content_type: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                template_id: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                rank: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                product_source: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '请输入广告名称', trigger: 'blur' }
                ],
                material_url: [
                    { required: true, message: '请上传广告图', trigger: 'blur' }
                ],
                content: [
                    { type: 'string', max: 15, message: '请输入15个字以内的描述文案', trigger: 'blur' }
                ],
                button_name: [
                    { type: 'string', max: 4, message: '请输入4个字以内的按钮名称', trigger: 'blur' }
                ],
                final_price: [
                    { required: true, message: '请输入付款价格', trigger: 'blur' }
                ],
                jump_link: [
                    { required: true, message: '请输入跳转链接', trigger: 'blur' }
                ],
                frequency: [
                    { required: true, message: '必选项', trigger: 'change' }
                ],
                popup_title: [
                    { type: 'string', required: true, message: '请输入弹窗标题', trigger: 'blur' }
                ],
                popup_content: [
                    { type: 'string', required: true, message: '请输入弹窗内容', trigger: 'blur' }
                ],
                button1_name: [
                    { type: 'string', required: true, message: '请输入Button1名称', trigger: 'blur' }
                ],
                button1_jump_link: [
                    { type: 'string', required: true, message: '请输入跳转链接', trigger: 'blur' }
                ],
                button2_name: [
                    { type: 'string', required: true, message: '请输入Button2名称', trigger: 'blur' }
                ],
                button2_jump_link: [
                    { type: 'string', required: true, message: '请输入跳转链接', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        handleSubmit (name) {
            if (this.formValidate.source == '0'){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.spinShow = true
                        if (this.formValidate.material_type == '3') {
                            this.formValidate.material_url = ''
                        }
                        createSelfAd(
                            {
                                template_id: parseInt(this.formValidate.template_id),
                                title: this.formValidate.title,
                                material_type: parseInt(this.formValidate.material_type),
                                material_url: this.formValidate.material_url,
                                content: this.formValidate.content,
                                button_name: this.formValidate.button_name,
                                jump_type: parseInt(this.formValidate.jump_type),
                                jump_link: this.formValidate.jump_link.trim(),
                                frequency: parseInt(this.formValidate.frequency),
                                duration: parseInt(this.formValidate.duration),
                                order_flow_flag: parseInt(this.formValidate.order_flow_flag),
                                vip_flow_flag: parseInt(this.formValidate.vip_flow_flag),
                                ad_content_type: parseInt(this.formValidate.ad_content_type),
                            }
                        ).then(res=>{
                            this.spinShow = false
                            if(res.data.code==200){
                                this.$Message.success('Success!');
                                this.$router.push({
                                    name: "adAdmin"
                                })
                            }else{
                                this.$Message.error(res.data.msg);
                            }
                        })
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            }else if (this.formValidate.source == '1'){
                if(this.formValidate.contents==""){
                    this.$Message.error('缺失广告参数');
                    return
                }
                createThirdAd(
                    {
                        content: this.formValidate.contents
                    }
                ).then(res=>{
                    if(res.data.code==200){
                        this.$Message.success('Success!');
                        this.$router.push({
                            name: "adAdmin"
                        })
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                })
            }else if (this.formValidate.source == '2'){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.spinShow = true
                        createProductAd(
                            {
                                template_id: parseInt(this.formValidate.template_id),
                                title: this.formValidate.title,
                                material_type: parseInt(this.formValidate.material_type),
                                material_url: this.formValidate.material_url,
                                content: this.formValidate.good_content,
                                jump_type: parseInt(this.formValidate.jump_type),
                                jump_link: this.formValidate.jump_link.trim(),
                                product_source: parseInt(this.formValidate.product_source),
                                price: parseFloat(this.formValidate.price),
                                coupon_amount: parseFloat(this.formValidate.coupon_amount),
                                final_price: parseFloat(this.formValidate.final_price),
                                rank: parseInt(this.formValidate.rank),
                                order_flow_flag: parseInt(this.formValidate.order_flow_flag),
                                vip_flow_flag: parseInt(this.formValidate.vip_flow_flag),
                                ad_content_type: parseInt(this.formValidate.ad_content_type),
                            }
                        ).then(res=>{
                            this.spinShow = false
                            if(res.data.code==200){
                                this.$Message.success('Success!');
                                this.$router.push({
                                    name: "adAdmin"
                                })
                            }else{
                                this.$Message.error(res.data.msg);
                            }
                        })
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            } else if (this.formValidate.source == '3') {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.spinShow = true
                        createImagePopupAd(
                            {
                                template_id: parseInt(this.formValidate.template_id),
                                title: this.formValidate.title,
                                material_type: parseInt(this.formValidate.material_type),
                                material_url: this.formValidate.material_url,
                                jump_type: parseInt(this.formValidate.jump_type),
                                jump_link: this.formValidate.jump_link.trim(),
                                product_source: parseInt(this.formValidate.product_source),
                                frequency: parseInt(this.formValidate.frequency),
                                order_flow_flag: parseInt(this.formValidate.order_flow_flag),
                                vip_flow_flag: parseInt(this.formValidate.vip_flow_flag),
                                ad_content_type: parseInt(this.formValidate.ad_content_type),
                            }
                        ).then(res=>{
                            this.spinShow = false
                            if(res.data.code==200){
                                this.$Message.success('Success!');
                                this.$router.push({
                                    name: "adAdmin"
                                })
                            }else{
                                this.$Message.error(res.data.msg);
                            }
                        })
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            } else if (this.formValidate.source == '4') {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.spinShow = true
                        if (this.formValidate.button1_jump_flag == '0') {
                            this.formValidate.button1_product_source = '1',
                            this.formValidate.button1_jump_link = '',
                            this.formValidate.button1_jump_type = '1'
                        }
                        if (this.formValidate.button2_jump_flag == '0') {
                            this.formValidate.button2_product_source = '1',
                            this.formValidate.button2_jump_link = '',
                            this.formValidate.button2_jump_type = '1'
                        }
                        let buttons = [
                            {
                                button_name: this.formValidate.button1_name,
                                jump_flag: this.formValidate.button1_jump_flag,
                                jump_type: this.formValidate.button1_jump_type,
                                jump_link: this.formValidate.button1_jump_link.trim(),
                                product_source: this.formValidate.button1_product_source
                            },
                            {
                                button_name: this.formValidate.button2_name,
                                jump_flag: this.formValidate.button2_jump_flag,
                                jump_type: this.formValidate.button2_jump_type,
                                jump_link: this.formValidate.button2_jump_link.trim(),
                                product_source: this.formValidate.button2_product_source
                            }
                        ]
                        createTextPopupAd(
                            {   
                                title: this.formValidate.title,
                                popup_title: this.formValidate.popup_title,
                                content: this.formValidate.popup_content,
                                frequency: parseInt(this.formValidate.frequency),
                                buttons: buttons,
                                order_flow_flag: parseInt(this.formValidate.order_flow_flag),
                                vip_flow_flag: parseInt(this.formValidate.vip_flow_flag),
                                ad_content_type: parseInt(this.formValidate.ad_content_type),
                            }
                        ).then(res=>{
                            this.spinShow = false
                            if(res.data.code==200){
                                this.$Message.success('Success!');
                                this.$router.push({
                                    name: "adAdmin"
                                })
                            }else{
                                this.$Message.error(res.data.msg);
                            }
                        })
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            }
        },
        getAdTemplateList(){
            adTemplateList().then(res=>{
                if(res.data.code==200){
                    this.templates=res.data.data.templates
                    this.templates.forEach((item, index) => {
                        this.template_dict[item.template_id+''] = item
                    })
                }
            })
        },
        handleSeleteSource(){
            if (this.formValidate.source == '3'){
                this.formValidate.template_id = '7'
            }
        },
        handleSeleteTemplate(item) {
            this.template_image = this.template_dict[item.value+'']['image']
            this.template_description = this.template_dict[item.value+'']['description']
            this.template_size = this.template_dict[item.value+'']['size']
            this.template_name = this.template_dict[item.value+'']['template_name']
            console.log(this.template_name);
            
            // 检查并重置不合适的频率选项
            if (this.formValidate.source == '0' && !['1', '5'].includes(String(item.value)) && 
                (this.formValidate.frequency == '7' || this.formValidate.frequency == '8')) {
                this.formValidate.frequency = '1' // 重置为默认值
            }
        },
        handleClearTemplate(){
            this.template_image = ""
            this.template_description = ""
            this.template_size = ""
            this.template_name = ""
        },
        handleUpload(file) {
            this.uploading = true;
            let file_size = file.size;
            if (file_size > 300 * 1024) {
                this.$Message.error("素材大小不能超过300k");
                this.uploading = false;
                return false;
            }
            let file_type = file.type.split("/")[1];
            let image_tyles = ['png', 'jpg', 'bmp', 'gif', 'jpeg'];
            let video_tyles = ['mp4'];
            
            if (this.formValidate.material_type == '1' && image_tyles.indexOf(file_type) > -1) {
                this.uploadFiles(file);
            } else if (this.formValidate.material_type == '2' && video_tyles.indexOf(file_type) > -1) {
                this.uploadFiles(file);
            } else {
                this.$Message.error("请上传正确格式的素材");
                this.uploading = false;
                return false;
            }
        },

        // 上传七牛云
        uploadFiles(file){
            new Promise(resolve=>{
                axios.get('https://pms.yolanda.hk/base/get_qiniu_uptoken_for_web?upload_type=advertisement',{
                                    
                }).then(res=>{    
                    let formData=new FormData()
                    formData.append('token',res.data.uptoken)
                    formData.append('file',file)
                    formData.append('key','ad_' + new Date().getTime())
                    axios.post('https://up-z0.qiniup.com',formData).then(res=>{
                        this.formValidate.material_url = 'https://qnplus-advertisement.qnniu.com/'+res.data.key
                        this.uploading = false
                    })              
                })                  
            })                      
        },
        handleChangePrice(){
            this.formValidate.price = (this.formValidate.coupon_amount - 0) + (this.formValidate.final_price - 0)
        },
        async openAiDialog(){ 
            if (!this.formValidate.title.trim()) { this.$Message.warning('请填写广告标题'); return }
            this.aiOpening = true
            try {
                if (this.$refs.aiDrawDialog && this.$refs.aiDrawDialog.handleWritePrompt) {
                    // 根据 template_name 替换成对应的宽高比
                    const ratio = this.getAspectRatioByTemplateName(this.template_name)
                    await this.$refs.aiDrawDialog.handleWritePrompt(this.formValidate.title, ratio, this.formValidate.ad_content_type)
                }
                // AI文案生成完成后再打开抽屉
                this.aiDialogVisible = true 
            } catch (e) {
                console.error(e)
            } finally {
                this.aiOpening = false
            }
        },
        // 模板名称到宽高比的推荐映射
        getAspectRatioByTemplateName(name){
            const map = {
                '竖版大图': '9:16',
                '横版大图': '16:9',
                '通栏大图': '21:9',
                '商品UI图': '1:1',
                '小图标': '16:9',
                '弹窗图片': '1:1',
            }
            return map[name] || 'AUTO'
        },
        handleSetAdImage(url){ 
            this.formValidate.material_url = url 
            this.aiDialogVisible = false
        }
    },
    created() {
        Cookies.set('active_name', '2');
        this.getAdTemplateList()
    },
};
</script>
<style scoped>
.box{
  width: 300px;
  height: 280px;
  border:1px solid rgb(158, 156, 156);
  padding: 10px;
  /* margin: 0px 20px 20px; */
}
.box1{
  width: 300px;
  /* height: 280px; */
  border:1px solid rgb(158, 156, 156);
  padding: 10px 10px 20px;
  /* margin: 0px 20px 20px; */
}
.box2{
  width: 400px;
  /* height: 280px; */
  border:1px solid rgb(158, 156, 156);
  padding: 10px 10px 20px;
  /* margin: 0px 20px 20px; */
}
.box3{
  max-height:150px;
  max-width:300px;
  /* border:1px solid rgb(158, 156, 156); */
  margin-top: 20px;
  text-align: left;
  /* float: left; */
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/Ad/AdCreate.vue